module.exports = __webpack_public_path__ + "img/bg_1@3x.e2810823.png";